import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginPage from "../pages/login/page";
import FocusPage from "../pages/focus/page";
import HabitPage from "../pages/habit/page";
import ProfilePage from "../pages/profile/page";
import GrowthPage from "../pages/growth/page";
import PostcardPage from "../pages/postcard/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/focus",
    element: <FocusPage />,
  },
  {
    path: "/habit",
    element: <HabitPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/growth",
    element: <GrowthPage />,
  },
  {
    path: "/postcard",
    element: <PostcardPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
